// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".news-list--layout {\n  display: flex;\n  flex-direction: column;\n  gap: 15px; }\n  .news-list--layout .news-list--container-list {\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px;\n    border-radius: 16px;\n    box-sizing: border-box;\n    box-shadow: var(--shadow); }\n  @media screen and (max-width: 1250px) {\n    .news-list--layout .news-list--container-list {\n      height: 100%; } }\n", ""]);
// Exports
module.exports = exports;
